import React, { Component } from 'react'

export default class CheckBoxField extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    const {item, remarks} = this.props
    return (
      <dl>
        <dt>{ item.input_name }</dt>
        <dd>
          {
            item.input_content.split(',').map((item, index) => {
              return(
                <React.Fragment key={index}>
                  <input type="checkbox" id={`form_checkbox_${index}`}/>
                  <label htmlFor={`form_checkbox_${index}`}>{item}</label>
                </React.Fragment>
              )
            })
          }
          <p className="cap">{remarks}</p>
        </dd>
      </dl>
    )
  }
}
